export default "__VITE_ASSET__D83FRzU5__"